import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Settings, LogOut } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
  DropdownMenuLabel,
} from '../../ui/dropdown-menu';
import { Avatar, AvatarFallback, AvatarImage } from '../../ui/avatar';
import blank from '../../../assets/blank.png';

interface IDropdownProfileProps {
  toggle: React.ReactNode;
  user: {
    avatar: boolean;
    name: string;
    email: string;
    avatarURL: string;
  };
}

const getInitials = (name?: string): string => {
  if (!name) return 'U';
  return name
    .split(' ')
    .map(n => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
};

const DropdownProfile: React.FC<IDropdownProfileProps> = ({ toggle, user }) => {
  const navigate = useNavigate();

  const handleClickUserAccountConfig = () => {
    navigate('/profile');
  };

  const handleClickLogout = () => {
    navigate('/logout');
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>{toggle}</DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuLabel>
          <div className="flex items-center gap-3 py-2">
            <Avatar className="h-10 w-10">
              <AvatarImage
                src={user.avatar ? user.avatarURL : blank}
                alt={user.name || 'Usuário'}
              />
              <AvatarFallback>{getInitials(user.name)}</AvatarFallback>
            </Avatar>
            <div className="flex flex-col space-y-1">
              <p className="text-sm font-medium leading-none">{user.name}</p>
              <p className="text-xs leading-none text-muted-foreground">
                {user.email || ''}
              </p>
            </div>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={handleClickUserAccountConfig}
          className="cursor-pointer"
        >
          <Settings className="mr-2 h-4 w-4" />
          <span>Minha Conta</span>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={handleClickLogout}
          className="cursor-pointer text-destructive focus:text-destructive"
        >
          <LogOut className="mr-2 h-4 w-4" />
          <span>Sair</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default DropdownProfile;
